<template>
  <div class="Assignment" style="position:relative">
    <p class="line" style="padding-bottom:2%">
        <b></b>添加图片
    </p>
    <div v-for="(item,index) in imgList" class="uploadimg">
        <i class="iconfont icon-shanchu" @click.stop="delImg(index)" style="float:right;position: relative;z-index: 100;left: 8px;top: -7px;"></i>
        <img :src="item"  style="position: absolute;left: 0;top: 0;height: 100%;width: 100%;">
    </div>
    <div class="up">
        <span class="plus" style="width: 40%;text-align: center;">+</span>
        <h3 style="margin-top: 10px;color: #dbdada;font-weight: 600;">添加图片</h3>
        <input @change="fileChange($event)" type="file" accept="image/*" multiple style="width: 100%;height: 100%;opacity: 0;position:absolute;top:0;left:0"/>
    </div>
    <p class="line" style="padding-top:3%">
        <b></b>添加链接
    </p>
    <ul>
        <li style="margin-right: 20%;">
            <el-input v-model="url" placeholder="HTTP://" class="input"></el-input>
        </li>
    </ul>
    
    <div class="check">
        <button class="active" @click="submit()">提交</button>
    </div>
    <div class="mark" v-show="msg">
        {{msg}}
    </div>
  </div>
</template>

<script>
export default {
  props:{

  },
  data () {
    return {
        imgList:[],
        base64img:[],
        size: 0,
        limit:5,
        url:'',
        msg:''
    }
  },
  components:{

  },
  mounted(){
      var _this = this;
      this.$http.post(api.get_my_type).then(function(res){
          if(res.data.code !== 100001){
              _this.msg = res.data.message;
          };
      })
  },
  methods: {
      //图片上传--------------------------------------------
        chooseType(e) {
            if(this.R){
                return;
            }
            this.clickDom = e.target;
            document.getElementById('upload_file_SMrenzheng').click();
        },
        fileChange(el) {
            if (!el.target.files[0].size) return;
            this.fileList(el.target);
            el.target.value = ''
        },
        fileList(fileList) {
            let files = fileList.files;
            for (let i = 0; i < files.length; i++) {
            //判断是否为文件夹
                if (files[i].type != '') {
                    this.fileAdd(files[i]);
                } else {
                    //文件夹处理
                    this.$message.error('请选择正确格式图片');
                }
            }
        },
        fileAdd(file) {
            if (this.limit !== undefined && this.limit < 0){
                this.$message.error('上传图片数量超限');
                return;
            }
            if (this.limit !== undefined) this.limit--;
            //总大小
            this.size = this.size + file.size;
            //判断是否为图片文件
            if (file.type.indexOf('image') == -1) {
                this.$message.error('请选择正确格式图片');
            } else {
                let reader = new FileReader();
                let image = new Image();
                let _this = this;
                reader.readAsDataURL(file);
                reader.onload = function () {
                    file.src = this.result;
                    image.onload = function(){
                        // console.log(file.src);
                        _this.imgList.push(file.src);
                        _this.base64img.push(file.src);
                    };
                image.src= file.src;
                }
            }
        },
        delImg(index) {
            if (this.limit !== undefined) this.limit++;
            this.imgList.splice(index, 1);
            this.base64img.splice(index,1);
        },
        //图片上传--------------------------------------------
        submit(){
            if(this.base64img.length == 0){
                this.$message.error('请上传欠款凭证');
                return;
            }else if(this.url.length == 0){
                this.$message.error('请添加链接');
                return;
            }
            var _this = this;
            let param = new URLSearchParams();
            param.append("base64", '1');
            param.append("base64data", this.base64img.join(',,,,,,'));
            param.append("url", this.url);
            this.$http.post(api.add_court_column,param).then(function(res){
                if(res.data.code == 100001){
                    _this.$message({type: 'success',message: res.data.message});
                    // _this.base64img = [];
                    // _this.imgList = [];
                    // _this.limit = 5;
                    // _this.url = '';
                    setTimeout(()=>{
                        _this.$router.push({path:'/index'})
                    },1200)
                }else{
                    _this.$message.error(res.data.message);
                };
            })
        },
  }   
}



</script>

<style scoped >

.Assignment{
    background:#FFFFFF;
    padding: 3% 3%;
}
.Assignment .line{
    color: #2fb8c2;
    font-weight: bold;
}
.Assignment .line b{
    display: inline-block;
    width: 5px;
    background: #2fb8c2;
    height: 20px;
    vertical-align: bottom;
    margin-right: 1rem;
    border-radius: 10px;
}
.Assignment ul{
    overflow:hidden;
}
.Assignment ul li{
    float:left;
    box-sizing: border-box;
    width:40%;
    margin-top: 10px;
    padding: 30px 0;
    border-bottom: 1px solid #d3d3d3;
    
}
.Assignment ul li span{
    display: inline-block;
    width: 21%;
    text-align:left;
}
.Assignment ul li>label{
    text-align:center;
    width:35%
    
}
.select{
    text-align: right;
}
.select span{
    float:left;
    line-height:40px;
}
.check{
    padding-top: 3%;
    text-align:center;
}
.check button{
    border: none;
    outline: none;
    padding: 20px 50px;
    border-radius: 10px;
    background: #FFFFFF;
    border: 1px solid #d3d3d3;
    margin: 0 50px;
    cursor: pointer;
}
.check button:hover{
    background:#2fb8c2;
    color:#ffffff;
}
.check button.active{
    background:#2fb8c2;
    color:#ffffff;
}
.input{
    width:100%
}
.tag{
    float: left;
    font-size: 12px;
    padding: 5px;
    border: 1px solid #f0f0f0;
    margin: 5px 5px 5px 0;
    cursor: pointer;
}


.uploadimg{
    width: 105px;
    height: 105px;
    border-radius: 10px;
    display: inline-block;
    float: left;
    margin-right: 10px;
    position:relative;
}
.up{
    background: #f1f1f1;
    width: 105px;
    height: 105px;
    position: relative;
    text-align:center;
    font-size: 0.8rem;
    border-radius: 10px;
    display: inline-block;
}
.plus{
    font-size: 3rem;
    display: inline-block;
    color: #e6e5e5;
    background: #dbdada;
    border-radius: 50%;
    width: 42px;
    line-height: 42px;
    margin-top: 20px;
 }
.mark{
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    line-height:500px;
    text-align:center;
    color:#ffffff;
    font-size:1.6rem;
    background: rgba(0,0,0,0.3);
}



</style>



// WEBPACK FOOTER //
// src/common/court.vue